import { useState, useEffect } from "react";

import { serviceBackdropGet, serviceBackdropSet } from "services/graphql/call";

export const useMainBackdrop = (options = {}) => {
  const [backdropSelect, setBackdropSelect] = useState(
    options.backdropSelect || null,
  );
  const [backdropActive, setBackdropActive] = useState(null);

  const setBackdrop = (value) => {
    const backdrop = serviceBackdropSet(value);
    setBackdropSelect(backdrop);
  };

  useEffect(() => {
    const flags = [
      // west europe
      "gb",
      "ch",
      "fr",
      "de",
      "it",
      "es",
      "nl",
      "se",
      "no",
      "fi",
      "dk",
      "be",
      "at",
      "ie",
      "pt",
      "gr",
      // north america
      "us",
      "ca",
      "mx",
      // rollout
      // // east europe
      // "ru",
      // "pl",
      // "cz",
      // "hu",
      // "ro",
      // "bg",
      // // south america
      // "br",
      // "ar",
      // "co",
      // "ve",
      // // asia
      // "cn",
      // "jp",
      // "kr",
      // "in",
      // "sg",
      // "hk",
      // // africa
      // "za",
      // "ng",
      // "eg",
      // "ke",
      // "ma",
    ];

    function setBackdropBodyClass(className) {
      if (className === "landing") {
        // set initial guest landing backdrop
        document.body.className = "backdrop dripflag";
        document.body.style.backgroundImage = `url(/images/logos/entzy-events.png)`;
        document.body.style.backgroundSize = "150%";
      } else if (className.includes("dripflag")) {
        let flagCode = className.split("-")[1];
        document.body.style.backgroundSize = "";
        document.body.className = "backdrop dripflag";
        document.body.style.backgroundImage = `url(/images/flags/${flagCode}.png)`;
      } else {
        document.body.style.backgroundImage = "";
        document.body.className = className;
      }
    }

    function activateFlags() {
      let index = 0;
      return setInterval(() => {
        let randomFlag = flags[Math.floor(Math.random() * flags.length)];
        setBackdropBodyClass("dripflag-" + randomFlag);
        index = (index + 1) % flags.length;
      }, 5000);
    }

    let user = options.user || { connected: false };
    let backdrop, interval;

    if (user.connected) {
      // connected users:
      // set static backdrop based on user setting
      if (backdropSelect) {
        backdrop = backdropSelect;
      } else {
        backdrop = serviceBackdropGet();
      }
      setBackdropBodyClass(backdrop);
      setBackdropActive(backdrop);
    } else {
      // guest users:
      // on landing set a rotating backdrop of flags
      // preload flag images
      flags.forEach((flag) => {
        const img = new Image();
        img.src = `/images/flags/${flag}.png`;
      });

      // set initial landing image that auto clears
      setBackdropBodyClass("landing");
      if (backdropSelect) {
        document.body.style.backgroundSize = "";
      } else {
        setTimeout(() => {
          document.body.style.backgroundSize = "100%";
        }, 4000);
      }

      // transition to rotating flags after initial landing backdrop
      interval = activateFlags();

      // override rotating flags with static backdrop if user selects one
      if (backdropSelect) {
        clearInterval(interval);
        if (backdropSelect.endsWith("none")) {
          setBackdropActive(null);
          interval = activateFlags();
        } else {
          setBackdropBodyClass(backdropSelect);
          setBackdropActive(backdropSelect);
        }
      }

      return () => {
        clearInterval(interval);
      };
    }

    return () => {
      document.body.className = "";
    };
  }, [options.user, backdropSelect]);

  return [backdropActive, setBackdrop];
};

// USAGE
// useMainBackdrop(props);
// const [backdropActive, setBackdrop] = useMainBackdrop(props);
